import CryptoJS from 'crypto'
import qs from 'qs'

const publicKey = 'XiaobaI2022'
const ignoreStr = ['\r', '\n', '\r\n'] // 忽略的签名字符

/**
 * 生成签名
 */
export function createSign(params, timestamp) {
  let signParam = signParamsFormat(params)
  return createSha256(JSON.stringify(signParam), timestamp)
}

function signParamsFormat(params) {
  let str = qs.stringify(params, {
    sort: (a, b) => (a > b ? 1 : -1),
  })
  // 注意：[]里的值是数字时才能当作数组处理，否则会处理为对象；当索引不连续时，qs会自动把创建出的稀疏数组压缩，仅保留有值的顺序，如下
  // qs.parse('a[1]=c&a[5]=b');  // 结果是 ['c', 'b']
  // 所以下方按照对象解析，后递归判断处理数组
  let obj = qs.parse(str, {
    arrayLimit: 1000, // 最大解析数组长度
    parseArrays: false, // 按照对象解析
  })

  // 递归处理数组
  sequentToArray(obj, getStrReplaceReg())
  return obj
}

/**
 * 加签忽略字符的正则
 * @returns 正则reg ｜ null
 */
function getStrReplaceReg() {
  let replaceReg = null
  if (ignoreStr.length > 0) {
    let strs = ignoreStr.join('|')
    replaceReg = new RegExp(`${strs}`, 'gi')
  }
  return replaceReg
}

/**
 * @param {Object} 把对象中的数组性质（连续的数字下标） 递归转换为数组
 */
function sequentToArray(obj, replaceReg = null) {
  for (let key in obj) {
    if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
      let is_array = true
      let correct_index = 0
      for (let index in obj[key]) {
        if (isNaN(index) || index < 0) {
          is_array = false
          break
        }
        if (Number(index) !== correct_index) {
          is_array = false
          break
        }
        correct_index++
      }
      if (is_array) {
        obj[key] = Object.values(obj[key])
        obj[key].forEach((child) => {
          if (Object.prototype.toString.call(child) === '[object Object]') {
            sequentToArray(child, replaceReg)
          }
        })
      } else {
        // 向下递归
        sequentToArray(obj[key], replaceReg)
      }
    } else if (Object.prototype.toString.call(obj[key]) === '[object String]') {
      if (replaceReg) {
        obj[key] = obj[key].replace(replaceReg, '')
      }
    }
  }
}

function createSha256(paramJson, timestamp) {
  let paramPattern = 'param_json' + paramJson + 'timestamp' + timestamp
  let signPattern = publicKey + paramPattern + publicKey
  return CryptoJS.createHmac('sha256', publicKey)
    .update(signPattern)
    .digest('hex')
}
